import * as react from "react";
import { singleton, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { sortBy, map, equalsWith } from "../../../fable_modules/fable-library-js.4.19.0/Array.js";
import { comparePrimitives, defaultOf, equals } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { spinner, checkbox, nothing } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { asString } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { Msg } from "./Types.fs.js";

export function dokumentenabrufBox(model, dispatch) {
    let children_18, children_4, children_2, children_16, children_6, s_1, s_2, children_14;
    const children_20 = [(children_18 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Dokumentenabruf Flatrate")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_16 = [(children_6 = [(s_1 = "Mit dem Abschluss des Dokumentenabruf-Abonnements haben Sie die Möglichkeit, sich über unseren Quick Finder die gescannten Dokumente, wie zum Beispiel Ihre eingereichten Belege, herunterzuladen.", s_1), react.createElement("br", {}), (s_2 = "Alle Details und Gebühren zur Flatrate entnehmen Sie bitte dem Hinweistext. Dieser erscheint, sobald Sie den Haken in der Checkbox setzen.", s_2)], react.createElement("p", {}, ...children_6)), (children_14 = toList(delay(() => {
        let testExpr, filialen;
        const matchValue = model.Filialen;
        return (matchValue != null) ? (((testExpr = matchValue, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) ? singleton(nothing) : ((filialen = matchValue, singleton(map((f_1) => {
            let children_8, children_10;
            let isChecked;
            const matchValue_1 = f_1.DokumentenabrufStatus;
            isChecked = ((matchValue_1.tag === 1) ? true : (matchValue_1.tag === 2));
            const children_12 = [(children_8 = [toText(printf("%s %s"))(f_1.Name1)(f_1.Name2)], react.createElement("td", {}, ...children_8)), (children_10 = toList(delay(() => {
                let arg_2;
                const matchValue_2 = f_1.GueltigBis;
                return (matchValue_2 != null) ? singleton((arg_2 = asString(matchValue_2), toText(printf("bis %s"))(arg_2))) : singleton(checkbox(isChecked, (b) => {
                    dispatch(new Msg(2, [f_1.FilialeId, b]));
                }, f_1.FilialeId));
            })), react.createElement("td", {
                className: "pull-right",
            }, ...children_10))];
            return react.createElement("tr", {}, ...children_12);
        }, sortBy((f) => f.Name1, filialen, {
            Compare: comparePrimitives,
        })))))) : singleton(spinner);
    })), react.createElement("table", {
        className: "table table-striped",
    }, ...children_14))], react.createElement("div", {
        className: "card-body paragraphs",
    }, ...children_16))], react.createElement("div", {
        className: "flat-card is-auto  profile-info-card",
    }, ...children_18))];
    return react.createElement("div", {
        className: "column is-12",
    }, ...children_20);
}

export function view(model, dispatch, navigateTo) {
    const children = [dokumentenabrufBox(model, dispatch)];
    return react.createElement("div", {
        className: "columns is-account-grid is-multiline einstellungen",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
